import { Modal } from '@cmhc-schl/hearth-ui';
import React, { memo } from 'react';
import { createPortal } from 'react-dom';

interface PricingScenariosProps {
  isOpen: boolean;
  id: string;
  onClose: () => void;
  onClick: () => void;
  title: string;
  primary: string;
  secondary: string;
  children?: React.ReactNode;
}

const PricingScenariosComponent = ({
  isOpen,
  id,
  onClose,
  onClick,
  title,
  primary,
  secondary,
  children
}: PricingScenariosProps) => {
  return createPortal(
    <Modal
      id={id}
      isActive={isOpen}
      title={title}
      onDismissalCallback={onClose}
      shouldCloseOnBackgroundClick
      bodyContent={children}
      modalButtons={{
        primaryButton: {
          name: 'primary',
          text: { value: primary },
          onClick: onClick
        },
        secondaryButton: {
          name: 'cancel-btn',
          text: { value: secondary },
          onClick: onClose
        }
      }}
    />,
    document.body
  );
};

export const PricingScenarios = memo(PricingScenariosComponent);
